export * from './main';
export * from './constants';

import { List } from 'immutable';
import PropTypes from 'prop-types';
import { EIKAIWA_ICON_BLANK } from 'app/constants/Fonts';
import {
  FREEFORM,
  MULTI_CHOICE,
  MULTI_CHOICE_MANY,
  POOL,
  POOL_MANY,
} from './constants';

export const QUIZ_TYPES = List([
  FREEFORM,
  MULTI_CHOICE,
  MULTI_CHOICE_MANY,
  POOL,
  POOL_MANY,
]);

export const isMultiChoice = (quizType: string) =>
  quizType === MULTI_CHOICE.id || quizType === MULTI_CHOICE_MANY.id;

export const isPool = (quizType: string) =>
  quizType === POOL.id || quizType === POOL_MANY.id;

// Fill-in-the-blank embedding marker, that may appear inside question/sentence text.
export const FIB_EMBEDDING_MARKER = '<<<QUIZ>>>';
// The `FIB_EMBEDDING_MARKER` marker will be converted to this unicode emoji character when
// displayed in the UI.
export const FIB_UI_MARKER = EIKAIWA_ICON_BLANK;

export const quizTypePropType = PropTypes.oneOf([...QUIZ_TYPES.map((type) => type.id)]);
